import React from 'react';

import PropTypes from 'prop-types';

// Components
import { Mui } from 'components';

const useStyles = Mui.makeStyles(theme => ({
  dialogPaper: {
    margin: theme.spacing(3),
    width: `calc(100% - ${theme.spacing(6)})`,
    maxWidth: `calc(100% - ${theme.spacing(6)})`,
    height: '95vh',
    maxHeight: '95vh',
    display: 'flex',
    flexDirection: 'column',
  },
  dialogContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    padding: `${theme.spacing(2)}px !important`,
  },
  dialogContentInner: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    minHeight: 0,
  },
}));

function ModelSelection({
  children,
  isLoading,
  open,
  title,
  query,
  setQuery,
  onClose,
  ErrorView,
  FiltersView,
  GridView,
  ListView,
  OtherView,
}) {
  // Hooks
  const classes = useStyles();

  // Constants
  const { viewMode: selectedViewMode } = query;
  const viewModes = [
    {
      value: 'grid',
      icon: 'grid_view',
      label: 'grade',
      hidden: !GridView,
    },
    {
      value: 'list',
      icon: 'view_list',
      label: 'lista',
      hidden: !ListView,
    },
    {
      value: 'other',
      icon: 'more_horiz',
      label: 'outro',
      hidden: !OtherView,
    },
  ].filter(mode => !mode.hidden);

  return (
    <Mui.Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={false}
      scroll="paper"
      PaperProps={{ className: classes.dialogPaper }}>
      <Mui.DialogTitle disableTypography>
        <Mui.Box display="flex" justifyContent="space-between" alignItems="center">
          <Mui.Typography variant="h5" color="textPrimary">
            {title}
          </Mui.Typography>
          <Mui.IconButton onClick={onClose}>
            <Mui.Icon>close</Mui.Icon>
          </Mui.IconButton>
        </Mui.Box>
      </Mui.DialogTitle>
      <Mui.DialogContent dividers className={classes.dialogContent}>
        <Mui.Box className={classes.dialogContentInner}>
          {children}

          {!!ErrorView && ErrorView()}

          {FiltersView ? (
            FiltersView({ query, setQuery, viewModes })
          ) : (
            <Mui.Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Mui.Box flexGrow={1} />
              <Mui.Box display="flex" alignItems="center" gridGap={10}>
                {viewModes.map(mode => (
                  <Mui.Tooltip key={mode.value} title={`Visualização em ${mode.label}`}>
                    <Mui.IconButton
                      onClick={() => setQuery({ ...query, viewMode: mode.value })}
                      color={selectedViewMode === mode.value ? 'primary' : 'default'}>
                      <Mui.Icon>{mode.icon}</Mui.Icon>
                    </Mui.IconButton>
                  </Mui.Tooltip>
                ))}
              </Mui.Box>
            </Mui.Box>
          )}

          {isLoading ? (
            <Mui.Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              flex={1}
              minHeight={0}>
              <Mui.CircularProgress color="primary" />
            </Mui.Box>
          ) : (
            <Mui.Box flex={1} display="flex" flexDirection="column" minHeight={0}>
              {!!GridView && selectedViewMode === 'grid' && GridView()}
              {!!ListView && selectedViewMode === 'list' && ListView()}
              {!!OtherView && selectedViewMode === 'other' && OtherView()}
            </Mui.Box>
          )}
        </Mui.Box>
      </Mui.DialogContent>
    </Mui.Dialog>
  );
}

ModelSelection.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  query: PropTypes.object,
  setQuery: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  ErrorView: PropTypes.func,
  FiltersView: PropTypes.func,
  GridView: PropTypes.func,
  ListView: PropTypes.func,
  OtherView: PropTypes.func,
};

ModelSelection.defaultProps = {
  isLoading: false,
  query: {},
  setQuery: () => {},
};

export default ModelSelection;
